<template>
    <Card :title="$t('labels.exit_declaration')">
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.warehouse')">
                        <Select
                            :model-value="exitDeclaration?.warehouse_id"
                            :selected-value="selectedWarehouse?.name"
                            :options="warehouses"
                            option-key="id"
                            :disabled="true"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.currency')">
                        <Select
                            :model-value="selectedCurrency?.uuid"
                            :selected-value="selectedCurrency?.name"
                            @update:model-value="$emit('update:selected-currency', $event)"
                            :options="currencies"
                            :disabled="canModify"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.rate')">
                        <Input
                            type="number"
                            :model-value="exitDeclaration?.currency_rate"
                            @update:model-value="$emit('update:currency-rate', $event)"
                            :disabled="canModify"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-2">
                    <FormGroup :label="$t('labels.status')">
                        <Select
                            :model-value="selectedStatus?.uuid"
                            :selected-value="selectedStatus?.name"
                            @update:model-value="$emit('update:selected-status', $event)"
                            :options="exitDeclarationStatuses"
                        />
                    </FormGroup>
                </div>
                <div class="col-12 col-sm-6 col-xl-4">
                    <FormGroup :label="$t('labels.order')">
                        <InputGroup>
                            <Autocomplete
                                :url="`/projects/${$route.params.projectUuid}/crm/orders`"
                                :model-value="selectedOrder?.uuid"
                                :selected-value="selectedOrder?.name"
                                :disabled="canModify"
                                :can-be-empty="true"
                                :query-params="{ extra_fields: ['client'] }"
                                @update:model-value="$emit('update:selected-order', $event)"
                            >
                                <template #optionContent>
                                    <span v-if="selectedOrder">{{ selectedOrder.id }} - {{ selectedOrder.client?.name }} - {{ selectedOrder.sum }}</span>
                                </template>
                                <template #optionItem="{option}">
                                    <span>{{ option.id }} - {{ option.client?.name }} - {{ option.sum }}</span>
                                </template>
                            </Autocomplete>
                            <template #append>
                                <router-link v-if="selectedOrder?.uuid" class="btn btn-link" :to="{ name: 'OrderProducts', params: { orderUuid: selectedOrder.uuid } }">
                                    {{ $t('buttons.go_over') }}
                                </router-link>
                                <span v-else class="btn btn-link disabled">
                                    {{ $t('buttons.go_over') }}
                                </span>
                            </template>
                        </InputGroup>
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end flex-wrap" style="gap: .5rem">
            <AppButton color="light" @click="$emit('delete')">
                <i class="icon-trash mr-2"></i>
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton color="indigo" @click="$emit('edit')">
                <i class="icon-floppy-disk mr-2"></i>
                <span>{{ $t('buttons.save') }}</span>
            </AppButton>
        </div>
    </Card>
</template>

<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Select from '../../../../../components/new/form/select/AppSelect.vue';
import Input from '../../../../../components/new/form/Input.vue';
import Autocomplete from '../../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import InputGroup from '../../../../../components/new/form/InputGroup.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
export default {
    name: 'ExitDeclarationCard',
    components: {
        Card, FormGroup, Select, Input, Autocomplete, InputGroup, AppButton
    },
    props: {
        exitDeclaration: {
            type: Object,
            default: null
        },
        selectedCurrency: {
            type: Object,
            default: null
        },
        selectedStatus: {
            type: Object,
            default: null
        },
        exitDeclarationStatuses: {
            type: Array,
            default: () => []
        },
        currencies: {
            type: Array,
            default: () => []
        },
        selectedWarehouse: {
            type: Object,
            default: null
        },
        warehouses: {
            type: Array,
            default: () => []
        },
        selectedOrder: {
            type: Object,
            default: null
        }
    },
    emits: ['update:selected-currency', 'update:currency-rate', 'update:selected-status', 'update:selected-order', 'delete', 'edit'],
    computed: {
        canModify() {
            if (!this.exitDeclaration) {
                return true
            }
            return this.exitDeclaration.status?.type === 'fail'
        }
    }
}
</script>
